module.exports = __webpack_public_path__ + "img/CL.9b2c32e5.svg";